//# sourceMappingURL=proposal.mjs.map
/// <reference types="./proposal.d.mts" />
import * as $proposal_element from "../../../data_types/data/proposal_element.mjs";
import * as $answer from "../../../data_types/data/proposal_element/answer.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { Store } from "../../data/store.mjs";

function upsert_answers(old, new$) {
  let _block;
  let _pipe = $list.map(old, (a) => { return [a.id, a]; });
  _block = $dict.from_list(_pipe);
  let old_dict = _block;
  let _pipe$1 = new$;
  let _pipe$2 = $list.fold(
    _pipe$1,
    old_dict,
    (acc, val) => {
      let _pipe$2 = acc;
      return $dict.upsert(_pipe$2, val.id, (_) => { return val; });
    },
  );
  return $dict.values(_pipe$2);
}

function upsert_element(old, new$) {
  let _block;
  let _pipe = $list.map(old, (pe) => { return [$proposal_element.id(pe), pe]; });
  _block = $dict.from_list(_pipe);
  let old_dict = _block;
  let _pipe$1 = new$;
  let _pipe$2 = $list.fold(
    _pipe$1,
    old_dict,
    (acc, val) => {
      let _pipe$2 = acc;
      return $dict.upsert(
        _pipe$2,
        $proposal_element.id(val),
        (_) => { return val; },
      );
    },
  );
  return $dict.values(_pipe$2);
}

export function update(store, msg) {
  if (msg instanceof $msg.ApiReturnedProposals) {
    let pagination = msg.proposals;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      new $remote.Loaded(pagination),
      store.page_index,
      store.proposal_elements,
      store.answers,
      store.translations,
      store.label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedProposalElements) {
    let proposal_id = msg.proposal_id;
    let elements = msg.elements;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      (() => {
        let _pipe = store.proposal_elements;
        return $dict.upsert(
          _pipe,
          proposal_id,
          (old) => {
            if (old instanceof Some) {
              let old$1 = old[0];
              return upsert_element(old$1, elements);
            } else {
              return elements;
            }
          },
        );
      })(),
      store.answers,
      store.translations,
      store.label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedAnswers) {
    let proposal_id = msg.proposal_id;
    let answers = msg.answers;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      (() => {
        let _pipe = store.answers;
        return $dict.upsert(
          _pipe,
          proposal_id,
          (old) => {
            if (old instanceof Some) {
              let old$1 = old[0];
              return upsert_answers(old$1, answers);
            } else {
              return answers;
            }
          },
        );
      })(),
      store.translations,
      store.label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  } else {
    let proposal_id = msg.proposal_id;
    let translations = msg.translations;
    let _pipe = new Store(
      store.connections,
      store.organizations,
      store.organizations_tags,
      store.organizations_users,
      store.organizations_invitations,
      store.organizations_enabled_connections,
      store.organizations_ai_config,
      store.organizations_qm_rows,
      store.connected_sockets,
      store.projects,
      store.proposals,
      store.page_index,
      store.proposal_elements,
      store.answers,
      (() => {
        let _pipe = store.translations;
        return $dict.insert(_pipe, proposal_id, translations);
      })(),
      store.label_translations,
      store.label_translations_search,
      store.label_translations_language_filter,
      store.label_translations_sort,
      store.client,
      store.organization,
      store.route,
      store.user,
      store.user_id,
      store.content_library,
      store.ingestion_control_sources,
      store.ingestion_control_sources_visibility,
      store.loading,
      store.users,
      store.roles,
      store.maintenance_mode,
      store.data_sources,
      store.analytics,
      store.metrics_groups,
      store.dashboard_options,
      store.project_files,
      store.weaviate_migrations,
      store.weaviate_collections,
      store.sitemap_urls,
    );
    return $pair.new$(_pipe, $effect.none());
  }
}
